<div class="table-container" *ngIf="tab === 'global'">
  <table class="table-header">
    <colgroup>
      <col width="30%"/>
      <col width="50%"/>
      <col width="10%" *ngIf="!am_i_division_user"/>
      <col width="10%" *ngIf="!am_i_division_user"/>
    </colgroup>
    <thead>
      <th>Name</th>
      <th>Descriptions</th>
      <th style="text-align: right" *ngIf="!am_i_division_user">Users</th>
      <th *ngIf="!am_i_division_user"></th>
    </thead>
  </table>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-body" *ngIf="!isLoading">
    <table>
      <colgroup>
        <col width="30%"/>
        <col width="50%"/>
        <col width="10%" *ngIf="!am_i_division_user"/>
        <col width="10%" *ngIf="!am_i_division_user"/>
      </colgroup>
      <tbody>
        <ng-container *ngIf="!filteredGlobalRoles?.length">
          <tr *ngIf="!hasReadMemberPermission || !hasReadRolePermission" style="text-align: center; color: #999;">
            <td colspan="11">No Permission for Permission Groups</td>
          </tr>
          <tr *ngIf="hasReadMemberPermission && hasReadRolePermission" style="text-align: center; color: #999;">
            <td colspan="11">No Permission Groups</td>
          </tr>
        </ng-container>
        <tr class="has-child" *ngFor="let role of filteredGlobalRoles" (click)="gotoDetail(role)">
          <td>{{role.name}}</td>
          <td>{{role.description}}</td>
          <td style="text-align: right" *ngIf="!am_i_division_user">{{role.user_cnt}}</td>
          <td style="text-align:right" *ngIf="!am_i_division_user">
            <div class="more-content v-center" #globalRoleActionMenus [id]="'global-role-'+role?.role_id" (mouseover)="setMorePosition('global-role-',role)">
              <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(role)">
                <i class="material-icons" style="font-size: 20px; color: hsla(0, 0%, 0%, 0.87);">more_horiz</i>
              </div>
              <div class="more" [class.show]="role.isShowMenu" [id]="'global-role-more-'+role.role_id">
                <div class="more-item" (click)="$event.stopPropagation(); openEditDialog(role)">Edit</div>
                <div class="more-item danger" (click)="$event.stopPropagation(); openDeleteDialog(role)">Delete</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="table-container" *ngIf="tab === 'division'">
  <table class="table-header">
    <colgroup>
      <col width="30%"/>
      <col width="50%"/>
      <col width="10%" *ngIf="!am_i_division_user"/>
      <col width="10%" *ngIf="!am_i_division_user"/>
    </colgroup>
    <thead>
      <th>Name</th>
      <th>Descriptions</th>
      <th style="text-align: right" *ngIf="!am_i_division_user">Users</th>
      <th *ngIf="!am_i_division_user"></th>
    </thead>
  </table>
  <div class="table-body">
    <table>
      <colgroup>
        <col width="30%"/>
        <col width="50%"/>
        <col width="10%" *ngIf="!am_i_division_user"/>
        <col width="10%" *ngIf="!am_i_division_user"/>
      </colgroup>
      <tbody>
        <tr *ngIf="!isLoading && (!hasReadMemberPermission || !hasReadRolePermission)" style="text-align: center; color: #999;">
          <td colspan="11">No Permission for Permission Groups</td>
        </tr>
        <tr *ngIf="!filteredDivisionRoles?.length && (hasReadMemberPermission && hasReadRolePermission)" style="text-align: center; color: #999;">
          <td colspan="11">No Permission Groups</td>
        </tr>
        <ng-container *ngIf="(hasReadMemberPermission && hasReadRolePermission) && !isLoading">
          <tr class="has-child" *ngFor="let role of filteredDivisionRoles" (click)="gotoDetail(role)">
            <td>{{role.name}}</td>
            <td>{{role.description}}</td>
            <td style="text-align: right" *ngIf="!am_i_division_user">{{role.user_cnt}}</td>
            <td style="text-align:right" *ngIf="!am_i_division_user">
              <div class="more-content v-center" #divisionRoleActionMenus [id]="'division-role-'+role?.role_id" (mouseover)="setMorePosition('division-role-',role)">
                <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(role)">
                  <i class="material-icons" style="font-size: 20px; color: hsla(0, 0%, 0%, 0.87);">more_horiz</i>
                </div>
                <div class="more" [class.show]="role.isShowMenu" [id]="'division-role-more-'+role.role_id">
                  <div class="more-item" (click)="$event.stopPropagation(); openEditDialog(role)">Edit</div>
                  <div class="more-item danger" (click)="$event.stopPropagation(); openDeleteDialog(role)">Delete</div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>